import { render, staticRenderFns } from "./AccountCertificationForm.vue?vue&type=template&id=b4f7fb92&"
import script from "./AccountCertificationForm.vue?vue&type=script&lang=js&"
export * from "./AccountCertificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports